import {useCopilotQuotaGate as useCopilotQuotaGateCore} from '@github-ui/agent-sessions/hooks/use-copilot-quota-gate'

import {useLayoutBaseRepository} from '../../stores/selectors'

/**
 * PR-side adapter for the shared Copilot quota gate. Reads the repo identifier
 * from the app-wide layout store (so it works at every render site, including
 * the sticky mini-header rendered outside the diff-scoped PullRequestStore) and
 * delegates the quota/mention logic to `@github-ui/agent-sessions`.
 */
export function useCopilotQuotaGate(text: string) {
  const baseRepository = useLayoutBaseRepository()
  return useCopilotQuotaGateCore(text, `${baseRepository.ownerLogin}/${baseRepository.name}`)
}
